/** When your routing table is too long, you can split it into small modules **/

const datahunterRouter = {
	id: 1500000,
	path: '/dataHunter',
	component: () =>
		import(/* webpackChunkName: "dataHunter" */ '@/leniuview/dataHunter/index'),
	name: '数据大屏',
	hidden: true,
	meta: {
		title: 'dataHunter.dataHunter',
		noCache: true,
		roles: [1500000]
	}
}

export default datahunterRouter
